/** Digits only - autofill and people typing from the card both insert spaces. */
export function normalizeCardNumber(raw: string | null | undefined): string {
  return (raw ?? '').replace(/\D/g, '');
}

/** 12-19 digits passing the Luhn checksum the processor applies. */
export function isValidCardNumber(digits: string): boolean {
  if (!/^\d{12,19}$/.test(digits)) {
    return false;
  }

  let sum = 0;
  for (let i = 0; i < digits.length; i++) {
    let d = +digits[digits.length - 1 - i];
    if (i % 2 === 1) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
  }
  return sum % 10 === 0;
}

/** Amex (34/37) uses a 4-digit code, every other brand 3; CardSecure rejects anything else. */
export function isValidCvv(cvv: string | null | undefined, cardDigits: string): boolean {
  return (/^3[47]/.test(cardDigits) ? /^\d{4}$/ : /^\d{3}$/).test(cvv ?? '');
}
